/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FavoriteCategory = {
    properties: {
        id: {
    type: 'number',
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        category: {
    type: 'string',
    isRequired: true,
},
        createdAt: {
    type: 'string',
},
    },
};